var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page"},[_c('b-container',[_c('b-row',[_c('b-col',{staticClass:"col-md-6 col-sm-12"},[(_vm.chartData)?_c('vue-plotly',{staticClass:"chart",attrs:{"data":_vm.chartData,"layout":_vm.layout}}):_vm._e()],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }